module.exports = __webpack_public_path__ + "img/icon_company_address.515845f1.png";